import React, { useState, useEffect, useRef, useMemo } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import BrandConfigurationReportTab from './brandConfigurationTab';
import Sorting from '../../components/company_panel/common/sorting';
import { capitalizeAllFirstLetters, capitalizeFirstLetter, formateDate, formateDateWithMonth, formateDateWithTime, formateIdArray, formatTime, getBrandId, getCompany, getOutletId, showPrice, TrimText, getExcelColumnWidths } from '../../helpers/commonFunctions';
import CustomPagination from '../../components/company_panel/common/custompagination';
import Loader from '../../components/company_panel/common/loader';
import notFound from '../../../src/assets/company/img/no-record-found.png'
import CustomRangepicker from '../../components/company_panel/common/rangepicker';
import { ListBrandSalesReport, ExportBrandSalesReport } from '../../services/company_panel/brandReport.services';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { LOADER_TIME, SOCKET_EVENTS } from '../../utils/Constants';
import { SOCKET_CLIENT } from '../../utils/socket';
import { GetActiveOrderModes } from '../../services/company_panel/setting/orderModeConfigurationService';
import { GetBrandsHavingOutlets } from '../../services/company_panel/brandService';
import { GetBrandOutletsList } from '../../services/company_panel/outletService';
import $ from "jquery";
import CustomModal from '../../components/company_panel/common/customModal';
import Swal from 'sweetalert2';
import GlobalLoader from '../../components/company_panel/common/globalLoader';
import { TagPicker } from 'rsuite';


const BrandSalesReportList = () => {

    const breadcrumbs = [{ title: "Dashboard", url: "/company/dashboard" }, { title: "Pages", url: "" },];
    const [list, setList] = useState([]);
    const [dataLength, setDataLength] = useState();
    const [itemPerPage, setItemPerPage] = useState(10);
    const [sorting, setSorting] = useState({});
    const [defaultSorting, setDefaultSorting] = useState(true);
    const [page, setPage] = useState(1);
    const [loader, setLoader] = useState(true);
    const [globalLoader, setGlobalLoader] = useState(false);
    const [search, setSearch] = useState({});
    const [globalSearch, setGlobalSearch] = useState("");
    const [resetdate, setResetDate] = useState(false);
    const selectRef = useRef(null);
    const [orderType, setOrderType] = useState();
    const [modalData, setModalData] = useState([]);

    const [brandList, setBrandList] = useState([]);
    const [outletList, setOutletList] = useState([]);
    const [selectedBrandIds, setSelectedBrandIds] = useState([]);
    const [selectedOutletIds, setSelectedOutletIds] = useState([]);

    const [dateFilterValue, setDateFilterValue] = useState([]);
    const [businessDateFilterValue, setBusinessDateFilterValue] = useState([]);

    // server-side export progress (driven by socket EXPORT_PROGRESS on the company register id room).
    // Completed / failed are handled globally in companyLayout (download / toast) so the user is
    // notified on whatever page they are on; here we only render the live progress bar.
    const [exportProgress, setExportProgress] = useState(null);
    const [exporting, setExporting] = useState(false);
    const exportJobIdRef = useRef(null);

    useEffect(() => {
        // This component only ever listens to the PROGRESS event (the live bar).
        // Completed / failed are handled globally in companyLayout (download / toast).
        const handleExportProgress = (response) => {
            const data = response?.data;
            if (!data || !data.jobId) return;
            if (response?.event !== SOCKET_EVENTS.REPORTS.SALES.EXPORT_PROGRESS) return;
            // only react to the export this page triggered
            if (exportJobIdRef.current && data.jobId !== exportJobIdRef.current) return;

            const percent = Number(data.percent) || 0;
            setExportProgress({
                status: percent >= 100 ? 'completed' : 'progress',
                percent,
                processed: data.processed,
                total: data.total,
            });

            // once progress is complete, finish the bar and re-enable the button
            if (percent >= 100) {
                setExporting(false);
                exportJobIdRef.current = null;
                setTimeout(() => setExportProgress(null), 3000);
            }
        };

        SOCKET_CLIENT.on('GET-DATA', handleExportProgress);
        return () => {
            SOCKET_CLIENT.off('GET-DATA', handleExportProgress);
        };
    }, []);

    useEffect(() => {
        const getData = setTimeout(() => {
            if (search) {
                setLoader(true)
                setTimeout(() => {
                    const formData = new FormData()
                    formData.append("page", page)
                    formData.append("per_page", itemPerPage)
                    formData.append("sort", JSON.stringify(sorting))
                    formData.append("search", JSON.stringify(search))
                    formData.append("global_search", globalSearch)
                    formData.append('company_id', getCompany().company_id);
                    ListBrandSalesReport(formData).then(data => {
                        setDataLength(data?.data?.response?.count || 0);
                        setList(data?.data?.response?.rows || [])
                        setLoader(false);
                    }).catch(error => {
                        console.log("error ====> ", error);
                        setList([]);
                        setDataLength(0);
                        Swal.fire({
                            customClass: 'swal-wide',
                            position: 'absolute',
                            icon: 'error',
                            title: error?.response?.data?.errors?.message || error?.message,
                            showConfirmButton: false,
                            timer: 1000,
                            toast: true,
                            position: 'top-right',
                        })
                        setLoader(false);
                    })
                }, 500);
            }
        }, 300);
        return () => clearTimeout(getData);
    }, [sorting, search, globalSearch, page])

    useEffect(() => {
        GetBrandsHavingOutlets(getCompany().company_id).then(data => {
            setBrandList(data && data.data && data.data.response ? data.data.response : []);
        }).catch(error => {
            console.log("error=====>", error)
        })
    }, [])

    const handleSort = (e, column) => {
        setDefaultSorting(false);
        let sort = { order: 0, column: column };
        if (e.target.classList.contains("assc")) {
            sort.order = -1;
        } else {
            sort.order = 1;
        }
        setSorting(sort);
    }

    const prepareSearch = (key, value) => {
        let sr = { ...search };
        if (Array.isArray(value)) {
            if (value.length > 0) {
                sr[key] = value;
            } else {
                delete sr[key];
            }
        } else if (String(value).length > 0) {
            sr[key] = value;
        } else {
            delete sr[key];
        }

        if(key == 'business_date'){
            setDateFilterValue([]);
            delete sr['created'];
        }else if(key == 'created'){
            setBusinessDateFilterValue([])
            delete sr['business_date'];
        }

        setSearch(sr);
    }

    const handleBrandChange = (selectedBrands) => {
        const brands = selectedBrands || [];
        setSelectedBrandIds(brands);

        if (brands.length === 0) {
            setOutletList([]);
            setSelectedOutletIds([]);
            const sr = { ...search };
            delete sr.brand_ids;
            delete sr.outlet_ids;
            setSearch(sr);
            return;
        }

        GetBrandOutletsList({ brand_ids: JSON.stringify(brands) }).then(data => {
            const outlets = data && data.data && data.data.response ? data.data.response : [];
            setOutletList(outlets);
            const validOutletIds = outlets.map(o => o.id);
            const filteredSelectedOutlets = selectedOutletIds.filter(id => validOutletIds.includes(id));
            setSelectedOutletIds(filteredSelectedOutlets);

            const sr = { ...search };
            sr.brand_ids = brands;
            if (filteredSelectedOutlets.length > 0) {
                sr.outlet_ids = filteredSelectedOutlets;
            } else {
                delete sr.outlet_ids;
            }
            setSearch(sr);
        }).catch(error => {
            console.log("error=====>", error)
        });
    }

    const handleOutletChange = (selectedOutlets) => {
        const outlets = selectedOutlets || [];
        setSelectedOutletIds(outlets);
        prepareSearch('outlet_ids', outlets);
    }

    const removeBrand = (brandId) => {
        handleBrandChange(selectedBrandIds.filter(id => id !== brandId));
    }

    const removeOutlet = (outletId) => {
        handleOutletChange(selectedOutletIds.filter(id => id !== outletId));
    }

    const brandData = brandList?.map(item => ({
        label: capitalizeAllFirstLetters(item?.name),
        value: item?.id
    })) || [];

    const filteredOutletData = outletList?.map(item => ({
        label: `${capitalizeAllFirstLetters(item?.outlet_name)}${item?.short_code ? ` (${item.short_code})` : ''}`,
        value: item?.id
    })) || [];

    const resetFilter = (e) => {
        e.preventDefault()
        setGlobalSearch("")
        setSelectedBrandIds([]);
        setSelectedOutletIds([]);
        setSearch({})
        setResetDate(!resetdate)
        if ($("#resetFilter")[0]) {
            $("#resetFilter")[0].selectedIndex = 0
        }
    }


    const generateOrderId = (orderId) => {
        let id = orderId;
        let countOfDigits = 0;
        while (id) {
            id = Math.floor(id / 10);
            countOfDigits += 1;
        }

        if (countOfDigits >= 4) {
            return orderId
        }
        let zerosCount = 4 - countOfDigits;
        let generatedZeros = '';
        while (zerosCount) {
            generatedZeros += '0';
            zerosCount -= 1;
        }
        return `${generatedZeros}${orderId}`;
    }


    const getOrderItemsNames1 = (data) => {
        return data && data.menu_items
            ? data.menu_items.join(', ')
            : 'N/A';
    };



    const headerMapping = {
        "brand_name": "Brand Name",
        "outlet_short_code": "Outlet Short Code",
        "outlet_name": "Outlet Name",
        "order_id": "Order ID",
        "customer_name": "Customer Name",
        "customer_number": "Customer Number",
        "customer_id": "Customer ID",
        "order_by": "Order By",
        "total_price": "Total Price",
        "total_price_with_tax": "Total Price With Tax",
        "payment_method": "Payment Method",
        "payment_status": "Payment Status",
        "order_status": "Status",
        "refunded_amount": "Refunded Amount",
        "order_type": "Order Mode",
        "aggregator_name": "Aggregator Name",
        "aggregator_external_id": "Aggregator ID",
        "business_date": "Business Date",
        "date": "Date",
        "time": "Time"
    };

    const handleExport = () => {
        setExporting(true);
        setExportProgress({ status: 'progress', percent: 0 });
        const formData = new FormData()
        formData.append("sort", JSON.stringify(sorting))
        formData.append("search", JSON.stringify(search))
        formData.append("global_search", globalSearch)
        formData.append('company_id', getCompany().company_id);
        ExportBrandSalesReport(formData).then(data => {
            const body = data?.data?.response || data?.data || {};
            const jobId = body.jobId || body.job_id || data?.data?.jobId;
            const message = data?.data?.message || body.message || 'Export started';
            if (jobId) {
                exportJobIdRef.current = jobId;
            }
            Swal.fire({
                customClass: 'swal-wide',
                icon: 'success',
                title: message,
                showConfirmButton: false,
                timer: 3000,
                toast: true,
                position: 'top-right',
            });
        }).catch(error => {
            console.log("error ====> ", error);
            Swal.fire({
                customClass: 'swal-wide',
                icon: 'error',
                title: error?.response?.data?.errors?.message || error?.message || 'Export failed',
                showConfirmButton: false,
                timer: 3000,
                toast: true,
                position: 'top-right',
            });
            setExporting(false);
            setExportProgress(null);
            exportJobIdRef.current = null;
        });
    };

    const handleExportOld = () => {
        setGlobalLoader(true);
        const formData = new FormData()
        formData.append("page", 1)
        formData.append("per_page", dataLength)
        formData.append("sort", JSON.stringify(sorting))
        formData.append("search", JSON.stringify(search))
        formData.append("global_search", globalSearch)
        formData.append('company_id', getCompany().company_id);
        ListBrandSalesReport(formData).then(data => {
            setDataLength(data.data.response.count);
            const listData = data && data.data && data.data.response ? data.data.response.rows : [];
            const printData = listData?.map((item) => {
                const transformedItem = {};
                const OrderID = item?.id || 'N/A';
                const customerName = item?.customer?.customer_name || item?.customer_name || 'N/A';
                const customerNumber = item?.customer?.customer_number || 'N/A';
                const customerID = item?.customer?.id || item?.customer_id || 'N/A';
                const orderBy = item?.order_source == 'online'
                    ? 'Online'
                    : (item?.user ? `${item?.user?.first_name || ''} ${item?.user?.last_name || ''}`.trim() : 'N/A');
                const totalPrice = (item?.net_amount != null) ? showPrice(Number(item?.net_amount) - Number(item?.tax_total_price || 0)) : 'N/A';
                const totalPriceWithTax = (item?.net_amount != null) ? showPrice(Number(item?.net_amount)) : 'N/A';
                const paymentStatus = item?.transaction?.payment_status
                    ?
                        item?.transaction?.payment_status != 'refunded'
                        ?   capitalizeFirstLetter(item?.transaction?.payment_status)
                        :   item?.transaction?.refundReason?.type_of_refund == 'full' ? 'Refunded' : 'Partial Refunded'
                    : "N/A"
                const paymentMethod = item?.transaction?.tender_configuration?.name || item?.transaction?.payment_method || 'N/A';
                const orderStatus = item?.order_status == 'in_kitchen' ? 'In kitchen' : (capitalizeFirstLetter(item?.order_status) || 'N/A');
                const refundedAmount = item?.transaction?.refunded_amount ? `${item.transaction.refunded_amount}` : 0;
                const orderType = item?.order_mode_configuration?.name || 'N/A';
                const brandName = capitalizeFirstLetter(item?.brand?.name) || 'N/A';
                const outletName = capitalizeFirstLetter(item?.outlet?.outlet_name) || 'N/A';
                const outletShortCode = item?.outlet?.short_code || 'N/A';
                const aggregatorName = capitalizeFirstLetter(item?.aggregators_configuration?.name) || 'N/A';
                const aggregatorExternalId = item?.aggregator_external_id || 'N/A';
                const date = formateDateWithTime(item?.created_at) || 'N/A';
                const time = (new Date(item?.created_at)).toLocaleTimeString()
                const businessDateVal = formateDate(item?.business_date);

                for (const key in headerMapping) {
                    if (headerMapping.hasOwnProperty(key)) {
                        const newKey = headerMapping[key];
                        switch (key) {
                            case "order_id":
                                transformedItem[newKey] = '#' + (generateOrderId(OrderID));
                                break;
                            case "customer_name":
                                transformedItem[newKey] = capitalizeFirstLetter(customerName);
                                break;
                            case "customer_number":
                                transformedItem[newKey] = capitalizeFirstLetter(customerNumber);
                                break;
                            case "customer_id":
                                transformedItem[newKey] = '#' + (customerID);
                                break;
                            case "order_by":
                                transformedItem[newKey] = capitalizeFirstLetter(orderBy);
                                break;
                            case "total_price":
                                transformedItem[newKey] = totalPrice;
                                break;
                            case "total_price_with_tax":
                                transformedItem[newKey] = totalPriceWithTax;
                                break;
                            case "payment_method":
                                transformedItem[newKey] = capitalizeFirstLetter(paymentMethod);
                                break;
                            case "payment_status":
                                transformedItem[newKey] = capitalizeFirstLetter(paymentStatus);
                                break;
                            case "order_status":
                                transformedItem[newKey] = orderStatus;
                                break;
                            case "refunded_amount":
                                transformedItem[newKey] = refundedAmount;
                                break;
                            case "order_type":
                                transformedItem[newKey] = capitalizeFirstLetter(orderType);
                                break;
                            case "brand_name":
                                transformedItem[newKey] = (brandName);
                                break;
                            case "outlet_name":
                                transformedItem[newKey] = (outletName);
                                break;
                            case "outlet_short_code":
                                transformedItem[newKey] = outletShortCode;
                                break;
                            case "aggregator_name":
                                transformedItem[newKey] = (aggregatorName);
                                break;
                            case "aggregator_external_id":
                                transformedItem[newKey] = aggregatorExternalId;
                                break;
                            case "business_date":
                                transformedItem[newKey] = businessDateVal;
                                break;
                            case "date":
                                transformedItem[newKey] = date;
                                break;
                            case "time":
                                transformedItem[newKey] = time;
                                break;
                            default:
                                transformedItem[newKey] = 'N/A';
                                break;
                        }
                    }
                }
                return transformedItem;
            });

            const ws = XLSX.utils.json_to_sheet(printData, { header: Object.values(headerMapping) });
            ws['!cols'] = getExcelColumnWidths(printData, Object.values(headerMapping));
            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
            const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
            const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });
            saveAs(blob, 'General-Sales-Report.xlsx');
            setGlobalLoader(false);
        }).catch(error => {
            console.log("error ====> ", error);
            setGlobalLoader(false);
        })
    };

    const handleFilterChange = (e) => {
        if (e?.target.value) {
            prepareSearch("order_mode_id", e.target.value);
        } else {
            prepareSearch("order_mode_id", "");
        }
    };

    useEffect(() => {
        GetActiveOrderModes(getBrandId()).then(data => {
            setOrderType(data && data.data && data.data.response ? data.data.response : []);
        }).catch(error => {
            console.log("error=====>", error)
        })
    }, [])


    return (
        <>
            {globalLoader && <GlobalLoader/>}
            <div className="animation_fade">
                <div className='page-header d-flex align-items-center'>
                    <div className='page-header-left'>
                        <h4>Brand Reports</h4>
                    </div>
                    <div className='page-header-right ms-auto'>
                        <button onClick={handleExport} disabled={dataLength === 0 || exporting} className="btn btn-primary ms-2">{exporting ? 'Exporting...' : 'Export Report'}</button>
                    </div>
                </div>
                {exportProgress && (() => {
                    const isDone = exportProgress.status === 'completed';
                    const percent = exportProgress.percent || 0;
                    const accent = isDone ? '#22c55e' : '#2f9bff';
                    return (
                        <div style={{
                            display: 'flex', alignItems: 'center', gap: '16px',
                            background: '#fff', border: '1px solid #e7ecf3', borderLeft: `4px solid ${accent}`,
                            borderRadius: '12px', padding: '14px 18px', marginBottom: '16px',
                            boxShadow: '0 2px 10px rgba(16, 30, 54, 0.06)'
                        }}>
                            <div style={{
                                width: '40px', height: '40px', flexShrink: 0, borderRadius: '50%',
                                display: 'flex', alignItems: 'center', justifyContent: 'center',
                                background: isDone ? 'rgba(34,197,94,0.12)' : 'rgba(47,155,255,0.12)', color: accent
                            }}>
                                {isDone ? (
                                    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M20 6L9 17l-5-5" /></svg>
                                ) : (
                                    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" style={{ animation: 'spin 0.9s linear infinite' }}><path d="M21 12a9 9 0 1 1-6.219-8.56" /></svg>
                                )}
                            </div>
                            <div style={{ flex: 1, minWidth: 0 }}>
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', marginBottom: '8px' }}>
                                    <span style={{ fontWeight: 600, color: '#1f2d3d', fontSize: '14px' }}>
                                        {isDone ? 'Export completed' : 'Exporting brand sales report'}
                                        {exportProgress.total ? (
                                            <span style={{ fontWeight: 400, color: '#8a97a8', marginLeft: '8px', fontSize: '13px' }}>
                                                {(exportProgress.processed || 0).toLocaleString()} / {Number(exportProgress.total).toLocaleString()} records
                                            </span>
                                        ) : null}
                                    </span>
                                    <span style={{ fontWeight: 700, color: accent, fontSize: '14px', whiteSpace: 'nowrap' }}>{percent}%</span>
                                </div>
                                <div style={{ height: '8px', background: '#eef2f7', borderRadius: '999px', overflow: 'hidden' }}>
                                    <div style={{
                                        height: '100%', width: `${percent}%`, borderRadius: '999px',
                                        background: isDone ? accent : 'linear-gradient(90deg, #2f9bff, #6cb8ff)',
                                        transition: 'width 0.4s ease'
                                    }} />
                                </div>
                            </div>
                            <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
                        </div>
                    );
                })()}
                <div className="card custom-card overflow-hidden">
                    <div className='gap-20 border-bottom'>
                        <div className='col-12'>
                            <div className='d-flex justify-content-between align-items-center'>
                                <BrandConfigurationReportTab tab='sales' />
                            </div>
                        </div>
                    </div>
                    <div className="gap-20">
                        <div className='page-header d-flex align-items-center mb-0 flex-wrap'>
                            <div className='d-flex gap-3 align-items-center'>
                                <div className="form-group mb-0 rangepicker_container">
                                    <input type="search" className="form-control" value={globalSearch} placeholder="Search" onChange={(e) => { setGlobalSearch(e.target.value) }} />
                                </div>
                            </div>
                            <div className='page-header-right ms-auto'>
                                <div className='d-flex gap-3 align-items-center flex-wrap'>
                                    <div className="form-group mb-0 multi-filter-picker" style={{ width: '200px' }}>
                                        <TagPicker
                                            data={brandData}
                                            value={selectedBrandIds}
                                            onChange={handleBrandChange}
                                            placeholder="Select Brands"
                                            className='form-control form-control-select'
                                            cleanable={false}
                                            menuStyle={{ maxHeight: 200, overflowY: 'auto' }}
                                            renderMenu={menu => {
                                                const allChecked = brandData.length > 0 && selectedBrandIds.length === brandData.length;
                                                const toggleAll = () => {
                                                    if (allChecked) {
                                                        handleBrandChange([]);
                                                    } else {
                                                        handleBrandChange(brandData.map(b => b.value));
                                                    }
                                                };
                                                return (
                                                    <>
                                                        <div className='rs-picker-list-item cp'>
                                                            <div className={'rs-check-item rs-checkbox e_none' + (allChecked ? ' rs-checkbox-checked' : '')} onClick={toggleAll}>
                                                                <div className='rs-checkbox-checker'>
                                                                    <label htmlFor='brand-select-all'>
                                                                        <span className='rs-checkbox-control'>
                                                                            <input type='checkbox' id='brand-select-all' checked={allChecked} readOnly />
                                                                            <span className='rs-checkbox-inner'></span>
                                                                        </span>
                                                                        <span className='rs-checkbox-label'>Select All</span>
                                                                    </label>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        {menu}
                                                    </>
                                                );
                                            }}
                                            renderValue={(value, items) => {
                                                const count = items.length;
                                                if (count === 0) return null;
                                                if (count === 1) {
                                                    return <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{items[0]?.label}</span>;
                                                }
                                                return <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%' }}>{count} brands selected</span>;
                                            }}
                                        />
                                    </div>
                                    <div className="form-group mb-0 multi-filter-picker" style={{ width: '200px' }}>
                                        <TagPicker
                                            data={filteredOutletData}
                                            value={selectedOutletIds}
                                            onChange={handleOutletChange}
                                            placeholder="Select Outlets"
                                            className='form-control form-control-select'
                                            cleanable={false}
                                            menuStyle={{ maxHeight: 200, overflowY: 'auto' }}
                                            renderMenu={menu => {
                                                const allChecked = filteredOutletData.length > 0 && selectedOutletIds.length === filteredOutletData.length;
                                                const toggleAll = () => {
                                                    if (allChecked) {
                                                        handleOutletChange([]);
                                                    } else {
                                                        handleOutletChange(filteredOutletData.map(o => o.value));
                                                    }
                                                };
                                                return (
                                                    <>
                                                        <div className='rs-picker-list-item cp'>
                                                            <div className={'rs-check-item rs-checkbox e_none' + (allChecked ? ' rs-checkbox-checked' : '')} onClick={toggleAll}>
                                                                <div className='rs-checkbox-checker'>
                                                                    <label htmlFor='outlet-select-all'>
                                                                        <span className='rs-checkbox-control'>
                                                                            <input type='checkbox' id='outlet-select-all' checked={allChecked} readOnly />
                                                                            <span className='rs-checkbox-inner'></span>
                                                                        </span>
                                                                        <span className='rs-checkbox-label'>Select All</span>
                                                                    </label>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        {menu}
                                                    </>
                                                );
                                            }}
                                            renderValue={(value, items) => {
                                                const count = items.length;
                                                if (count === 0) return null;
                                                if (count === 1) {
                                                    return <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{items[0]?.label}</span>;
                                                }
                                                return <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%' }}>{count} outlets selected</span>;
                                            }}
                                        />
                                    </div>
                                    <div className="date-input">
                                        <CustomRangepicker business_date = {true} value = {businessDateFilterValue} GetDateRange={(e) => { prepareSearch("business_date", e) }}
                                        resetdate={resetdate} />
                                    </div>
                                    <button type="reset" value='Reset' onClick={resetFilter} className="btn btn-primary mr-2">Reset Filter</button>
                                </div>
                            </div>
                        </div>
                        {selectedBrandIds.length > 0 && (
                            <div className='d-flex flex-wrap gap-2 mt-2'>
                                <span className='text-muted me-1 align-self-center'>Brands:</span>
                                {selectedBrandIds.map(id => {
                                    const brand = brandList.find(b => b.id === id);
                                    if (!brand) return null;
                                    return (
                                        <span key={`b-${id}`} style={{ display: 'inline-flex', alignItems: 'center', backgroundColor: '#2f9bff', color: '#fff', borderRadius: '14px', padding: '4px 10px', fontSize: '13px', fontWeight: 500 }}>
                                            <span>{capitalizeAllFirstLetters(brand.name)}</span>
                                            <button type='button' aria-label='Remove' onClick={() => removeBrand(id)} style={{ background: 'transparent', border: 'none', cursor: 'pointer', marginLeft: 6, padding: 0, lineHeight: 1, color: '#fff', display: 'inline-flex', alignItems: 'center' }}>
                                                <svg width='12' height='12' viewBox='0 0 16 16' fill='currentColor' aria-hidden='true'><path d='M2.784 2.089l.069.058 5.146 5.147 5.146-5.147a.5.5 0 01.765.638l-.058.069L8.705 8l5.147 5.146a.5.5 0 01-.638.765l-.069-.058-5.146-5.147-5.146 5.147a.5.5 0 01-.765-.638l.058-.069L7.293 8 2.146 2.854a.5.5 0 01.638-.765z'></path></svg>
                                            </button>
                                        </span>
                                    );
                                })}
                            </div>
                        )}
                        {selectedOutletIds.length > 0 && (
                            <div className='d-flex flex-wrap gap-2 mt-2'>
                                <span className='text-muted me-1 align-self-center'>Outlets:</span>
                                {selectedOutletIds.map(id => {
                                    const outlet = outletList.find(o => o.id === id);
                                    if (!outlet) return null;
                                    return (
                                        <span key={`o-${id}`} style={{ display: 'inline-flex', alignItems: 'center', backgroundColor: '#e7f1ff', color: '#1565c0', border: '1px solid #b6d4fe', borderRadius: '14px', padding: '4px 10px', fontSize: '13px', fontWeight: 500 }}>
                                            <span>{capitalizeAllFirstLetters(outlet.outlet_name)}{outlet.short_code ? ` (${outlet.short_code})` : ''}</span>
                                            <button type='button' aria-label='Remove' onClick={() => removeOutlet(id)} style={{ background: 'transparent', border: 'none', cursor: 'pointer', marginLeft: 6, padding: 0, lineHeight: 1, color: '#1565c0', display: 'inline-flex', alignItems: 'center' }}>
                                                <svg width='12' height='12' viewBox='0 0 16 16' fill='currentColor' aria-hidden='true'><path d='M2.784 2.089l.069.058 5.146 5.147 5.146-5.147a.5.5 0 01.765.638l-.058.069L8.705 8l5.147 5.146a.5.5 0 01-.638.765l-.069-.058-5.146-5.147-5.146 5.147a.5.5 0 01-.765-.638l.058-.069L7.293 8 2.146 2.854a.5.5 0 01.638-.765z'></path></svg>
                                            </button>
                                        </span>
                                    );
                                })}
                            </div>
                        )}
                    </div>
                    <div className="tabler-wrap">
                        <div className="table-responsive">
                            <table className="table table-custom">
                                <thead>
                                    <tr>
                                        <th width="5%">
                                            <div className='sorting_column'>
                                                <span>Business Date</span>
                                                <Sorting sort={sorting} handleSort={handleSort} column="customer_orders.business_date" />
                                            </div>
                                        </th>
                                        <th width="5%">
                                            <span>Brand Name</span>
                                        </th>
                                        <th width="5%">
                                            <div className='sorting_column'>
                                                <span>Outlet Short Code</span>
                                            </div>
                                        </th>
                                        <th width="5%">
                                            <span>Outlet Name</span>
                                        </th>
                                        <th width="5%">
                                            <div className='sorting_column'>
                                                <span>Order ID  </span>
                                                <Sorting sort={sorting} handleSort={handleSort} column="customer_orders.id" />
                                            </div>
                                        </th>
                                        <th width="5%">
                                            <span>Customer Name</span>
                                        </th>
                                        <th width="5%">
                                            <div className='sorting_column'>
                                                <span>Customer Number</span>
                                            </div>
                                        </th>
                                        <th width="5%">
                                            <span>Customer ID</span>
                                        </th>
                                        <th width="5%">
                                            <span>Ordered By</span>
                                        </th>
                                        <th width="5%">
                                            <div className='sorting_column'>
                                                <span>Total Price</span>
                                            </div>
                                        </th>
                                        <th width="5%">
                                            <div className='sorting_column'>
                                                <span>Total Price With Tax</span>
                                            </div>
                                        </th>
                                        <th width="5%">
                                            <span>Payment Method</span>
                                        </th>
                                        <th width="5%">
                                            <span>Payment Status</span>
                                        </th>
                                        <th width="5%">
                                            <span>Status</span>
                                        </th>
                                        <th width="5%">
                                            <div className='sorting_column'>
                                                <span>Refunded Amount</span>
                                            </div>
                                        </th>
                                        <th width="5%">
                                            <span>Order Mode</span>
                                        </th>
                                        <th width="5%">
                                            <span>Aggregator Name</span>
                                        </th>
                                        <th width="5%">
                                            <div className='sorting_column'>
                                                <span>Aggregator ID</span>
                                            </div>
                                        </th>
                                        <th width="5%">
                                            <div className='sorting_column'>
                                                <span>Date</span>
                                                <Sorting sort={sorting} handleSort={handleSort} column="customer_orders.created_at" />
                                            </div>
                                        </th>
                                        <th width="5%">
                                            <span>Time</span>
                                            <Sorting sort={sorting} handleSort={handleSort} column="customer_orders.created_at" />
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {loader ?
                                        <tr>
                                            <td colSpan={20}><Loader /></td>
                                        </tr> : <>
                                            {list.length ? list?.map((row, i) => (
                                                <tr key={i}>
                                                    <td>{formateDateWithMonth((row?.business_date))}</td>
                                                    <td>{capitalizeFirstLetter(row?.brand?.name)}</td>
                                                    <td>{row?.outlet?.short_code ? row?.outlet?.short_code : 'N/A'}</td>
                                                    <td>{capitalizeFirstLetter(row?.outlet?.outlet_name)}</td>
                                                    <td>#{(generateOrderId(row?.id))}</td>
                                                    <td>{capitalizeFirstLetter(TrimText(row?.customer?.customer_name || row?.customer_name, 30))}</td>
                                                    <td>{row?.customer?.customer_number ? row?.customer?.customer_number : "-"}</td>
                                                    <td>#{(row?.customer?.id || row?.customer_id)}</td>
                                                    <td>{row?.order_source == 'online' ? 'Online' : (row?.user ? `${capitalizeFirstLetter(row?.user?.first_name)} ${capitalizeFirstLetter(row?.user?.last_name)}` : '-')}</td>
                                                    <td>{row?.net_amount != null ? `${showPrice(Number(row?.net_amount) - Number(row?.tax_total_price || 0))} SAR` : 'N/A'}</td>
                                                    <td>{row?.net_amount != null ? `${showPrice(Number(row?.net_amount))} SAR` : 'N/A'}</td>
                                                    <td>{capitalizeFirstLetter(row?.transaction?.tender_configuration?.name || row?.transaction?.payment_method)}</td>
                                                    <td>
                                                        {
                                                            row?.transaction?.payment_status
                                                            ?
                                                                row?.transaction?.payment_status != 'refunded'
                                                                ?   capitalizeFirstLetter(row?.transaction?.payment_status)
                                                                :   row?.transaction?.refundReason?.type_of_refund == 'full' ? 'Refunded' : 'Partial Refunded'
                                                            : "N/A"
                                                        }
                                                    </td>
                                                    <td>{row?.order_status == 'in_kitchen' ? 'In kitchen' : (capitalizeFirstLetter(row?.order_status) || 'N/A')}</td>
                                                    <td>{row?.transaction?.refunded_amount || 0} SAR</td>
                                                    <td>{capitalizeFirstLetter(row?.order_mode_configuration?.name)}</td>
                                                    <td>{row?.aggregators_configuration?.name ? capitalizeFirstLetter(row?.aggregators_configuration?.name) : "N/A"}</td>
                                                    <td>{row?.aggregator_external_id ? row?.aggregator_external_id : 'N/A'}</td>
                                                    <td>{formateDateWithMonth((row?.created_at))}</td>
                                                    <td>{(new Date(row?.created_at)).toLocaleTimeString()}</td>
                                                </tr>
                                            )) : <tr>
                                                <td colSpan={20} className="text-center">
                                                    <img src={notFound} style={{ width: "5%" }} alt="Not Found" />
                                                    <p>No record found</p>
                                                </td>
                                            </tr>
                                            }</>}
                                </tbody>
                            </table>
                        </div>
                        <div className='tabler-footer'>
                            <div className='d-flex align-items-center'>
                                <div id="example1_info" role="status" className="table-result" aria-live="polite"><b>Total Records : {dataLength ? dataLength : "0"}</b></div>
                                {dataLength && dataLength > 0 ?
                                    <CustomPagination datalength={dataLength} itemperpage={itemPerPage} setPage={setPage} currentPage={page} pageRoute={[{ name: "report", path: "/company/brand-report/sales_report/list" }]} /> : ""}
                            </div>
                        </div>
                    </div>
                </div>
                <ToastContainer
                    position="top-right"
                    hideProgressBar={false}
                    autoClose={true | 1000}
                    newestOnTop={true}
                    closeOnClick={false}
                    draggable={false}
                    rtl={false}
                />

            </div>

            <CustomModal
                title="Order Items"
                content={modalData}
            />
        </>
    );
}

export default BrandSalesReportList
